import { Component, OnInit } from '@angular/core';
import {UserPrivilegeService} from '../../../services/common/user-privilege/user-privilege.service';
import {LoaderService} from '../../../services/common/loader-service/loader.service';
import {
  StatisticsConfigurationApiService
} from '../../../services/api/settings/advanced/statistics/statistics-configuration-api.service';

@Component({
  selector: 'advanced-statistics',
  templateUrl: './advanced-statistics.component.html',
  styleUrls: ['./advanced-statistics.component.scss']
})
export class AdvancedStatisticsComponent implements OnInit {

  readonly minDaysforQouta = 90;
  readonly minDaysForStatistics = 31;
  readonly maxDaysForQuota = 365;
  maxDayForStatistics;
  canSubmit: boolean;
  statisticsSettings: any = {};


  constructor(private statisticsConfigurationApiService: StatisticsConfigurationApiService,
              private userPrivilege: UserPrivilegeService, private loaderService: LoaderService) { }

  ngOnInit(): void {
    this.canSubmit = this.userPrivilege.isAuthorized();
    this.initialization();
  }

  submit(): void{
    this.statisticsConfigurationApiService.editStatisticsConfiguration(this.statisticsSettings).subscribe(result => {
      this.initData(result);
    });
  }


  initialization(): void {
    this.loaderService.showMainContainer();
    this.statisticsConfigurationApiService.getStatisticsConfiguration().subscribe(statisticsRange => {
      this.initData(statisticsRange);
      this.loaderService.hideMainContainer();
    });
  }

  initData(statisticsConfigurations): void {
    this.statisticsSettings = statisticsConfigurations;
    this.maxDayForStatistics = statisticsConfigurations.maxDaysToKeepStatistics;
  }
}
